import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'analysis-callback',
  template: ``,
})
export class CallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const snapshot = this.route.snapshot;
    const rgxToken = /(?:access_token)\=([\S\s]*?)\&/;
    const accessToken = snapshot?.fragment.split(rgxToken)[1];
    localStorage.setItem('token', accessToken);
    this.router.navigate(['/']);
  }
}
